import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: { paddingHorizontal: 24 },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  text: {
    fontWeight: 'normal',
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral700,
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${colors.neutral200}`,
  },

  columns: {
    paddingBottom: 8,
    borderBottom: `1px solid ${colors.neutral}`,
  },
  content: {
    paddingHorizontal: 24,
  },
  table: {
    marginBottom: 28,
  },
  tableTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: colors.neutral900,
    marginBottom: 14,
  },
  headerItem: {
    fontWeight: 700,
    fontSize: 11,
    color: colors.neutral900,
  },

  headerItemLeft: {
    flex: 2,
    textAlign: 'left',
  },

  headerItemRight: {
    flex: 1,
    textAlign: 'right',
  },

  headerItemCenter: {
    flex: 1,
    textAlign: 'center',
  },

  rows: {
    flexDirection: 'column',
  },
  row: {
    flexDirection: 'row',
    minHeight: 42,
    alignItems: 'center',
  },

  rowCell: {
    fontSize: 11,
    color: colors.neutral900,
    fontWeight: 400,
  },
});
